import { render, staticRenderFns } from "./step-1.vue?vue&type=template&id=63b04ba0&scoped=true&"
import script from "./step-1.vue?vue&type=script&lang=js&"
export * from "./step-1.vue?vue&type=script&lang=js&"
import style0 from "./step-1.vue?vue&type=style&index=0&id=63b04ba0&lang=scss&scoped=true&"
import style1 from "./step-1.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b04ba0",
  null
  
)

export default component.exports